<template>
  <v-tooltip bottom>
    <slot slot="activator"></slot>
    <span>version: {{version}}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'version-tooltip',
  props: {
    version: Number
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Ui/VersionTooltip.vue